module.exports = __webpack_public_path__ + "static/img/huaishuBg.bffbb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuBg.png
// module id = LBMr
// module chunks = 0